'use client';

import { useSharedState } from '@/hooks/state/shared-state';
import { useTheaterContext, useUpdateTheaterContext } from '@/hooks/state/theater';
import { useTheatersContext, useUpdateTheatersContext } from '@/hooks/state/theaters';
import { useTheaterByTheaterId } from '@/hooks/theater/theater';
import { useTheatersByZipCode } from '@/hooks/theater/theaters';
import { useEffect } from 'react';

export const TheaterProvider = (): null => {
  const { data: sharedState } = useSharedState();
  const { data: theaterContext } = useTheaterContext();
  const { data: theatersContext } = useTheatersContext();
  const { data: theater } = useTheaterByTheaterId(sharedState?.lastViewedTheaterId || 0);
  const { data: theaters } = useTheatersByZipCode(theater?.zipcode || '');
  const { mutateAsync: updateTheaterContext } = useUpdateTheaterContext();
  const { mutateAsync: updateTheatersContext } = useUpdateTheatersContext();

  // since we are navigating between modern and legacy, we need to reset the header state
  // so this use effect is to ensure that when we come back to modern from legacy, the header is correct
  useEffect(() => {
    const updateTheaters = async (): Promise<void> => {
      if (!sharedState?.lastViewedTheaterId || !theater) {
        return;
      }

      if (theaterContext !== theater) {
        await updateTheaterContext(theater);
      }

      if (theatersContext !== theaters) {
        await updateTheatersContext(theaters);
      }
    };

    updateTheaters();
  }, [sharedState?.lastViewedTheaterId, theater, theaterContext, theaters, theatersContext, updateTheaterContext, updateTheatersContext]);

  return null;
};
